import { useAuth } from 'modules/auth/useAuth';
import { useCallback } from 'react';
import { useExpertProfileStore } from 'shared/hooks/stores/useExpertProfileStore';
import { useJobOrdersStore } from 'shared/hooks/stores/useJobOrdersStore';
import { useNotificationStore } from 'shared/hooks/stores/useNotificationStore';

export const useSignOut = (): [() => Promise<void>, boolean] => {
  const { signOut, loadings } = useAuth();
  const clearJobOrderLists = useJobOrdersStore((state) => state.clearJobOrderLists);
  const clearNotifications = useNotificationStore((state) => state.clearNotifications);
  const clearExpertProfile = useExpertProfileStore((state) => state.clearExpertProfile);

  const signOutUser = useCallback(async () => {
    await signOut();
    clearJobOrderLists();
    clearNotifications();
    clearExpertProfile();
  }, []);

  return [signOutUser, loadings.signOut];
};
